var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.75C6.30964 15.75 5.75 16.3096 5.75 17C5.75 17.6904 6.30964 18.25 7 18.25V15.75ZM27.8839 17.8839C28.372 17.3957 28.372 16.6043 27.8839 16.1161L19.9289 8.16117C19.4408 7.67301 18.6493 7.67301 18.1612 8.16117C17.673 8.64932 17.673 9.44078 18.1612 9.92893L25.2322 17L18.1612 24.0711C17.673 24.5592 17.673 25.3507 18.1612 25.8388C18.6493 26.327 19.4408 26.327 19.9289 25.8388L27.8839 17.8839ZM7 18.25H27V15.75H7V18.25Z",
    fill: "#FF6B00"
  })));
}

export default SvgArrowRight;